import axios from '@/plugins/axios';

export default {
    namespaced: true,

    state: {
        entities: [],
        entity: {}
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async fetch({ commit }) {
            const { data } = await axios.get(`/admin/collections`);
            commit('SET_ENTITIES', data);
            return data;
        },
        async get({ commit }, { entity_id, id }) {
            const { data } = await axios.get(`/admin/collections/${ id }`);
            commit('SET_ENTITY', data);
        },
        async save({ commit, state }) {
            let response = {};
            if(state.entity.id) {
                response = await axios.put(`/admin/collections/${ state.entity.id }`, state.entity);
            } else {
                response = await axios.post(`/admin/collections`, state.entity);
            }
            return response.data;
        },
        async delete({ commit }, { id }) {
            await axios.delete(`/admin/collections/${ id }`);
        },
    },

    getters: {}
}
